var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-autocomplete',_vm._g(_vm._b({staticClass:"mb-2",attrs:{"items":_vm.ringing_time_items,"update:search-input":"","hide-details":"auto"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }